<div class="p-4 sm:p-6 font-display">
  <div class="flex items-center justify-between w-full mb-4">
    <h2 class="text-lg sm:text-xl font-semibold text-[#1E1E1E]">
      Confirm Approval
    </h2>
    <button (click)="closeDialog()" class="rounded-full p-1">
      <i class="fa-solid fa-xmark text-lg text-gray-500 hover:text-gray-700"></i>
    </button>
  </div>
  <p class="text-[#767676] mb-4 text-sm">
    Are you sure you want to proceed with this confirmation? <br />
    Please review the details carefully before approving.
  </p>

  <ng-container [formGroup]="form">
    <textarea
      placeholder="Masukkan catatan"
      formControlName="note"
      class="w-full p-3 border rounded-lg focus:outline-none mb-4 text-sm"
      rows="4"
      *ngIf="approvalNote"
    ></textarea>
    <input
      type="file"
      #file
      name="file"
      class="hidden"
      multiple
      (change)="uploadFile($event)"
    />
    <div 
      *ngIf="approvalFile"
      (click)="file.click()"
      (drop)="handleDrop($event)"
      (dragover)="handleDragOver($event)"
      class="h-24 w-full bg-white rounded-lg border border-dashed border-[#1F9AA2] flex flex-col items-center justify-center mb-4 cursor-pointer">
      <mat-spinner [diameter]="50" *ngIf="uploadStatus"></mat-spinner>
      <ng-container *ngIf="!uploadStatus">
        <span class="text-sm text-[#3B3B3B] text-center px-2">Drag & Drop for the attachment file</span>
        <span class="text-xs text-[#8C8C8C]">ⓘ Max file size 25MB</span>
      </ng-container>
    </div>
    <div
      *ngIf="fileExists && approvalFile"
      class="flex flex-col sm:flex-row px-4 py-2 justify-between items-start sm:items-center bg-[#ECECEC] rounded-md mb-4 cursor-pointer"
      (click)="downloadFile()">
      <div class="flex items-center">
        <span class="text-sm fas fa-file text-[#1F9AA2] mr-2"></span>
        <span class="text-sm font-semibold text-[#3B3B3B] break-words">{{ fileName }}</span>
      </div>
      <span class="text-sm fa-solid fa-trash cursor-pointer mt-2 sm:mt-0" (click)="removeFile(); $event.stopPropagation()"></span>
    </div>
  </ng-container>

  <div class="flex flex-col sm:flex-row w-full justify-end items-center gap-2">
    <button
      (click)="submit()"
      [disabled]="form.invalid"
      class="text-white py-2 px-6 rounded-lg focus:outline-none w-full sm:w-auto"
      [ngClass]="{'bg-[#85E2B1] cursor-pointer': form.valid, 'bg-[#8C8C8C]': form.invalid}"
    >
      Submit
    </button>
    <button
      (click)="cancel()"
      class="bg-[#8C8C8C] text-white py-2 px-6 rounded-lg focus:outline-none w-full sm:w-auto"
    >
      Cancel
    </button>
  </div>
</div>
